import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2270f8e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ProcessingList" }
const _hoisted_2 = { class: "search" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "cornerMarker" }
const _hoisted_7 = { class: "topTag" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "detail" }
const _hoisted_10 = {
  key: 0,
  class: "item-img"
}
const _hoisted_11 = { class: "item-info" }
const _hoisted_12 = {
  key: 0,
  class: "vip"
}
const _hoisted_13 = { class: "profile" }
const _hoisted_14 = { class: "address" }
const _hoisted_15 = { class: "footer" }
const _hoisted_16 = { class: "time" }
const _hoisted_17 = { class: "btns" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("订阅该品种")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("打电话")
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_21 = { class: "telNum" }
const _hoisted_22 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanSearch = _resolveComponent("VanSearch")!
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanEmpty = _resolveComponent("VanEmpty")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VanSearch, {
        placeholder: "请输入关键字",
        modelValue: $setup.getListData.keyword,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.getListData.keyword) = $event)),
        "show-action": "",
        shape: "round"
      }, {
        action: _withCtx(() => [
          _createVNode(_component_VanButton, {
            size: "small",
            color: "#FFCC32",
            style: {"display":"block"},
            onClick: $setup.search
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _withDirectives(_createVNode(_component_VanList, {
      class: "list",
      loading: $setup.loading,
      "onUpdate:loading": _cache[1] || (_cache[1] = ($event: any) => (($setup.loading) = $event)),
      finished: $setup.finished,
      onLoad: $setup.getList,
      "immediate-check": false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
          return (_openBlock(), _createBlock($setup["ListItemAd"], {
            data: idx%5 == 0?$setup.addList[idx/5]:{},
            key: `item${idx}`
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: "listItem",
                onClick: ($event: any) => (_ctx.$router.push({name:"ProcessDetail",query:{id:item.id}}))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_VanImage, {
                      src: require("@/assets/img/jiaobiao.png")
                    }, null, 8, ["src"])
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_VanImage, {
                      src: require("@/assets/img/supply_top_tag.png")
                    }, null, 8, ["src"])
                  ], 512), [
                    [_vShow, item.supplyTop]
                  ]),
                  _createElementVNode("div", _hoisted_8, _toDisplayString(item.title), 1),
                  _createElementVNode("div", _hoisted_9, [
                    (item.photos != undefined && item.video != undefined)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                          _createVNode(_component_VanImage, {
                            src: item.photos?item.photos[0]:"",
                            radius: "4",
                            style: {"width":"100%","height":"100%"}
                          }, null, 8, ["src"]),
                          (item.video != undefined)
                            ? (_openBlock(), _createBlock(_component_VanIcon, {
                                key: 0,
                                class: "play",
                                name: "play-circle-o",
                                size: "40",
                                color: "#FFF"
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_11, [
                      (item.userCertification.vipRank > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_13, _toDisplayString(item.profile), 1),
                      _createElementVNode("div", _hoisted_14, "地区：" + _toDisplayString(item.address), 1),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, _toDisplayString($setup.moment(Number(item.refreshTime)).fromNow()), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createVNode(_component_VanButton, {
                            type: "success",
                            size: "small",
                            onClick: _withModifiers(($event: any) => ($setup.subscribe(item.categoryId)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _hoisted_18
                            ]),
                            _: 2
                          }, 1032, ["onClick"]), [
                            [_vShow, $setup.isSubscribe]
                          ]),
                          _createVNode(_component_VanButton, {
                            type: "primary",
                            size: "small",
                            color: "#FFCC32",
                            onClick: ($event: any) => ($setup.getTell(item.id))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ])
                      ])
                    ])
                  ])
                ])
              ], 8, _hoisted_4)
            ]),
            _: 2
          }, 1032, ["data"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished"]), [
      [_vShow, $setup.list.length]
    ]),
    _withDirectives(_createVNode(_component_VanEmpty, { description: "暂时没有该类处理" }, null, 512), [
      [_vShow, !$setup.list.length]
    ]),
    _createVNode($setup["RestrictDialog"], {
      modelValue: $setup.restrictShow,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.restrictShow) = $event)),
      code: $setup.restrictCode,
      type: "single"
    }, null, 8, ["modelValue", "code"]),
    _createVNode(_component_VanPopup, {
      class: "callDialog",
      show: $setup.isShowTel,
      "onUpdate:show": _cache[3] || (_cache[3] = ($event: any) => (($setup.isShowTel) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_20,
        _createElementVNode("div", _hoisted_21, "是否拨打 " + _toDisplayString($setup.tel), 1),
        _createElementVNode("a", {
          class: "call",
          href: `tel:${$setup.tel}`
        }, "立即呼叫", 8, _hoisted_22)
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}